<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {},
  metaInfo() {
    return {
      title: this.$t('metaData.title'),
      meta: [
        {
          property: "og:title",
          content: this.$t('metaData.title'),
        },
        {
          property: "og:description",
          content: this.$t('metaData.description'),
        },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
</script>
<style lang="scss">
.grecaptcha-badge { visibility: hidden; }
</style>

